module.exports = __webpack_public_path__ + "img/bg-header.d8f0e052.jpg";